import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DiretyCheckGuard } from 'src/app/shared/guard/direty-check.guard';
import { UserDefinedFieldsComponent } from './user-defined-fields.component';

const routes: Routes = [
  { path: '', component: UserDefinedFieldsComponent, canDeactivate: [DiretyCheckGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserDefinedFieldsRoutingModule { }
